module.exports = __webpack_public_path__ + "img/billing_history_report.94ceb667.svg";